import { Button, Popover } from '@pukka/ui-components';
import { IoIosClose } from 'react-icons/io';

interface MaxCampaignErrorProps {
  readonly outlets: (string | undefined)[];
}

function MaxCampaignError({ outlets }: MaxCampaignErrorProps) {
  return (
    <span className="whitespace-normal text-xs text-red-500" data-testid="error-message">
      {outlets.length > 1 ? (
        <Popover
          trigger={
            <button type="button" className="inline text-blue-300 underline">
              Multiple outlets
            </button>
          }
        >
          <div className="flex h-72 w-96 flex-col rounded border bg-white text-sm">
            <div className="bg-blue-400 px-7 py-4 text-white">List of Outlet</div>
            <ul className="list-disc overflow-y-scroll px-7 py-4">
              {outlets.map((outlet) => (
                <li key={outlet}>{outlet}</li>
              ))}
            </ul>
            <Popover.Close asChild className="absolute right-1 top-[12px]">
              <Button size="none">
                <IoIosClose size={28} color="white" />
              </Button>
            </Popover.Close>
          </div>
        </Popover>
      ) : (
        `'${outlets[0]}'`
      )}
      &nbsp;can not be assigned as it already has 5 campaign assigned. Discharge them from other campaign and try again.
    </span>
  );
}

export default MaxCampaignError;
